/**
 * Computes the api endpoint prefixed with account id recieved in the param
 * @param {String} accountId Account id whose record is to be updated
 * @param {String} endpoint Api endpoint to be appended with the account id
 */
export const getEndpoint = (accountId, endpoint) => `${accountId}/${endpoint}`;

/**
 * Replaces the user id {{userId}} dynamic string written in the url with the user id recieved in the param
 */
export const urlUserIdReplacer = (url, userId) => {
  const REPLACE_CHAR = "{{userId}}";
  return url?.includes(REPLACE_CHAR) ? url.replace("{{userId}}", userId) : url;
};
